import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { IonNav } from '@ionic/angular';
import { CaseService } from 'src/app/services/case.service';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.page.html',
  styleUrls: ['./payment-success.page.scss'],
})
export class PaymentSuccessPage implements OnInit {
  @ViewChild('paymentNav', { static: false }) paymentNav: IonNav;
  paymentInfo: any;
  showHeader = false;
  rootPage = null; 
  showSuccessContent = true;
  
  constructor(
    private router: Router, 
    public caseService: CaseService,
    private cdr: ChangeDetectorRef
  ) {
    // Get payment info from navigation state
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras?.state) {
      this.paymentInfo = navigation.extras.state['paymentInfo'];
      this.showHeader = navigation.extras.state['showHeader'] === true;
    }
  }

  ngOnInit() {
    // If no payment info, redirect to quick-pay
    if (!this.paymentInfo) {
      this.router.navigate(['/quick-pay'], { replaceUrl: true });
      return;}

    // Trigger change detection to ensure template updates
    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    // Set IonNav in case service after view is initialized
    if (this.paymentNav) {
      this.caseService.setMyNav(this.paymentNav);
      
      // Listen to navigation changes
      this.paymentNav.ionNavDidChange.subscribe(async () => {
        const activeView = await this.paymentNav.getActive();
        this.showSuccessContent = !activeView;
        this.cdr.detectChanges();
      });
    }
  }

  goToHome() {
    // Navigate to landing/home page
    this.router.navigate(['/landing'], { replaceUrl: true });
  }

  makeAnotherPayment() {
    // Navigate back to quick-pay
    this.router.navigate(['/quick-pay'], { replaceUrl: true });
  }
}
